import { ChangeDetectionStrategy, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { User } from 'app/core/user/user.types';
import { UserService } from 'app/core/user/user.service';
import { TranslateConfigService } from 'app/services/translate-config.service';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { NgClass } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { TranslateModule } from '@ngx-translate/core';
import { UserbackService } from 'app/common/service/userback.service';
import { SigninService } from 'app/services/signin.service';

@Component({
    selector: 'user',
    templateUrl: './user.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatButtonModule, MatMenuModule, MatIconModule, NgClass, MatDividerModule,
        TranslateModule]
})
export class UserComponent implements OnInit {
    @Input() showAvatar: boolean = true;
    user: User;


    userName: any;

    constructor(private _router: Router,
                private _userService: UserService,
                private translateConfigService: TranslateConfigService,
                private _userbackService: UserbackService,
                private _signinService: SigninService
    ) {
    }

    ngOnInit(): void {
        this.userName = JSON.parse(localStorage.getItem('userName'));
    }

    updateUserStatus(status: string): void {
        // Return if user is not available
        if (!this.user) {
            return;
        }

        // Update the user
        this._userService.update({
            ...this.user,
            status
        }).subscribe();
    }

    /**
     * Sign out
     */
    signOut(): void {
        this._signinService.logoutAPICall().subscribe({ error: () => {} });
        localStorage.removeItem('token');
        localStorage.removeItem('userEmailId');
        localStorage.removeItem('userId');
        localStorage.removeItem('groupId');
        localStorage.removeItem('firstName');
        localStorage.removeItem('lastName');
        localStorage.removeItem('userNavigation');
        localStorage.removeItem('addEditPermissions');
        localStorage.removeItem('userName');
        localStorage.removeItem('landingPage');
        localStorage.removeItem("closedFrames");
        localStorage.removeItem("variantType");
        localStorage.removeItem("helpCenterWidget");
        localStorage.removeItem("supportPageToken");
        localStorage.removeItem("userbackToken");
        this._userbackService.logoutUserback();
        this._router.navigate(['/sign-out']);
    }

    navigateToUserSettings(): void {
        // this._router.navigate(['users'], {queryParams: {id: btoa(localStorage.getItem('userId'))}});
        this._router.navigate(['/user-info']);

    }
}
